import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService {
  private url = environment.api;

  constructor(private http: HttpClient) {}

  /**
   * Calls GET /api/v1/workspaces/{workspaceId}
   * Returns the workspace record (workspaceCode, name, branding, etc.).
   */
  public getWorkspaceById(workspaceId: string): Observable<any> {
    if (!workspaceId) {
      return new Observable((observer) => {
        observer.error(new Error('workspaceId is required'));
      });
    }
    const endpoint = `${this.url}/api/v1/workspaces/${workspaceId}`;
    console.log('[WorkspaceService] fetching workspace by id:', endpoint);
    return this.http.get(endpoint);
  }
}
